<main>
  <div class="d-grid gap-4">
    <div class="page-header">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <i class="fas fa-arrow-left back-icon"></i>
        <div class="page-title">Media assets</div>
      </div>
    </div>

    <div class="d-flex justify-content-end align-items-center res-wrp">
      <app-button
        label="Upload images"
        [minWidth]="'12rem'"
        (clicked)="openAddMedia()"
      >
      </app-button>
    </div>

    <!-- Skeleton Loader -->
    <div class="media-grid" *ngIf="isLoading">
      <div class="card skeleton-card" *ngFor="let _ of skeletonArray">
        <div class="card-img-wrapper">
          <div class="skeleton-img"></div>
        </div>
      </div>
    </div>


    <div class="scroll-contain">
      <div class="media-grid" *ngIf="!isLoading && filteredMedia.length > 0">
        <div class="card" *ngFor="let media of filteredMedia; let i = index">
          <div class="card-img-wrapper">
            <img
              class="card-img"
              [src]="media.imagePath || fallbackImage"
              [alt]="media.name"
              loading="lazy"
              (error)="handleImageError($event)"
            />
            <div class="card-img-overlay">
              <img
                class="action-button"
                (click)="deleteMedia(media.id)"
                src="assets/images/Buttons/delete-button.svg"
                alt="Delete"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && filteredMedia.length === 0" class="faq-card">
      <div class="pb-3">
        <div class="empty-state">
          <i class="fas fa-folder"></i>
          <h4>No media assets found</h4>
        </div>
      </div>
    </div>
  </div>
</main>
